import React, { useState, useEffect } from "react";
import { getStoreById } from "../../../lib/apiCalls";
import { useParams } from "react-router-dom";
import EditStoresUi from "../../../ui/storesUi/editStoresUi";
import i18n from "../../../lib/i18n";
import { positionOfPackags, TopResultOfPackags } from "../../../lib/definitions";

export default function EditStores() {
  const [storeByIdData, setStoreByIdData] = useState({});
  const { storeId } = useParams();
  const t = i18n.t.bind(i18n);

  useEffect(() => {
    handleApi();
  }, []);

  const handleApi = async () => {
    try {
      const storeById = await getStoreById(storeId);
      setStoreByIdData({});
      setStoreByIdData(storeById.data?.data || {});
    } catch (err) {
      setStoreByIdData({});
    }
  };

  return (
    <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
      <div>
        <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">
          {t("edit_page_title.store")}
        </h1>
        <EditStoresUi
          storeByIdData={storeByIdData}
          TopResultOfPackags={TopResultOfPackags}
          positionOfPackags={positionOfPackags}
        />
      </div>
    </div>
  );
}
